import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Nav } from "@/components/Nav";
import { BrandMark } from "@/components/BrandMark";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import Planner from "@/pages/Planner";
import MyPlans from "@/pages/MyPlans";
import Outings from "@/pages/Outings";
import Friends from "@/pages/Friends";
import Vision from "@/pages/Vision";
import Invite from "@/pages/Invite";
import Deals from "@/pages/Deals";
import BusinessDashboard from "@/pages/BusinessDashboard";
import AdminAds from "@/pages/AdminAds";

const Splash = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
    <BrandMark size={64} className="animate-pulse" />
  </div>
);

const BUSINESS_PATHS = ["/business", "/vision"];

const Protected = () => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (user.role === "business") return BUSINESS_PATHS.includes(loc.pathname) ? <Outlet /> : <Navigate to="/business" replace />;
  if (!user.onboarded && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  if (loc.pathname.startsWith("/admin") && user.role !== "admin") return <Navigate to="/" replace />;
  return <Outlet />;
};

const Shell = () => (
  <div className="min-h-screen">
    <Nav />
    <main className="pt-16">
      <Outlet />
    </main>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route element={<Shell />}>
            <Route path="/vision" element={<Vision />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Planner />} />
              <Route path="/plans/:id" element={<Planner />} />
              <Route path="/plans" element={<MyPlans />} />
              <Route path="/outings" element={<Outings />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/profile" element={<Onboarding edit />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/invite/:token" element={<Invite />} />
              <Route path="/deals" element={<Deals />} />
              <Route path="/business" element={<BusinessDashboard />} />
              <Route path="/admin/ads" element={<AdminAds />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
